import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { ACTIONS } from '../../actions/actionTypes';
import Spinner from '../components/spinner';

class EnemBrowserView extends Component {
    constructor (props) {
        super(props);
        this.state = {
            user: null,
            reproved: {
                time: null,
                situation: false
            },
            date: null,
            interval: null,
            isReproved: false
        };
    }

    componentDidMount () {
        this.setTimeout();
    }

    setTimeout () {
        let reproved = JSON.parse(window.localStorage.getItem('reproved'));
        console.log('Reprovado', reproved);
        if (reproved !== null) {
            const interval = setInterval(() => {
                let date = new Date(this.state.reproved.time);
                date = new Date(date - Date.now());
                if (date <= 0) {
                    clearInterval(this.state.interval);
                    window.localStorage.setItem('reproved', null);
                    this.setState({interval: null, reproved: null, isReproved: false});
                } else {
                    this.setState({date: date});
                }
            }, 1000);
            let date = new Date(reproved.time);
            date = new Date(date - Date.now());
            this.setState({interval: interval, reproved: reproved, isReproved: true, date: date});
        }
    }

    renderTimeout () {
        let firstTime = JSON.parse(window.localStorage.getItem('firstTime'));
        if (this.state.isReproved) {
            let firstTime = JSON.parse(window.localStorage.getItem('firstTime'));
            if (firstTime === null) {
                window.localStorage.setItem('firstTime', false);
            }
            return (
                <div style={{fontSize: '0.9em', textAlign: 'center'}}>
                    <br />
                    <p>
                        Você foi reprovado, aguarde o tempo abaixo para fazer o ENEM novamente!
                    </p>
                    <h1 className='centerButton'>
                        {this.state.date.getMinutes() + ' : ' + ((this.state.date.getSeconds() >= 10) ? this.state.date.getSeconds() : '0' + this.state.date.getSeconds())}
                    </h1>
                </div>
            );
        } else {
            return (
                <div>
                    {(firstTime === null)
                    ? <h2>{'Hora de começar!'}</h2>
                    : <h2>{'Hora de começar!'}</h2>
                    }
                    <p style={{fontSize: '0.9em', textAlign: 'left'}}>
                        {(firstTime === null)
                        ? 'Para entrar na UFJF você precisará passar no ENEM. É seu primeiro desafio no game!'
                        : 'Você já está liberado para fazer o enem novamente'
                        }
                    </p>
                    <div style={{textAlign: 'center'}}>
                        {this.props.questionsLoading
                            ? <Spinner small />
                            : <div className='btn enem'
                                onClick={() => this.props.acceptSession()}>
                                <h4>Fazer prova do ENEM</h4>
                            </div>
                        }
                    </div>

                </div>
            );
        }
    }

    render () {
        return (
            <div className='browser interaction'>
                <div className='fixed'>
                    <div className='window-buttons'>
                        <div className='btn-circle' />
                        <div className='btn-circle' />
                        <div className='btn-circle' />
                    </div>
                    <header>
                        <span className='rounded-input'>{ 'https://enem.inep.gov.br' }</span>
                    </header>
                    <div className='content'>
                        <div className='card'>
                            {this.renderTimeout()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => ({
    questionsLoading: state.questionReducer.loading
});

const mapDispatchToProps = (dispatch) => ({
    push: (location) => dispatch(push(location)),
    acceptSession: () => dispatch({
        type: ACTIONS.ACCEPT_SESSION
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(EnemBrowserView);



// WEBPACK FOOTER //
// ./src/views/EnemView/enemBrowserView.js